// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__14LZp","right":"styles_right__3dsiR"};